export default defineNuxtPlugin(async () => {
  const route = useRoute();
  if (route.path === '/sign_in' || route.path === '/log-in') return;

  const {ensureValidSession} = useAuthGuard();
  const hasSession = await ensureValidSession(undefined, {redirect: false});
  if (!hasSession) return;

  const session = useSessionStore();
  const users = useUsersStore();
  const preferences = usePreferencesStore();
  const appState = useAppStateStore();
  const notifications = useNotificationStore();

  await nextTick();
  await session.getCurrentUser();

  if (process.client) {
    let timer;
    const stopNotificationPolling = () => clearInterval(timer);
    const startNotificationPolling = () => {
      stopNotificationPolling();
      notifications.getNewCount();
      timer = setInterval(notifications.getNewCount, useRuntimeConfig().public.notificationCountRefreshInterval);
    };

    session.getUserStoreInfo();

    // Auth cookies are shared across tabs, but nothing pushes their changes into this
    // tab's reactive state (e.g. impersonation toggled in another tab). Resync on focus.
    document.addEventListener('visibilitychange', async () => {
      if (document.visibilityState !== 'visible') return;

      const hasSession = await ensureValidSession(undefined, {redirect: false});
      if (!hasSession) return;

      await session.resyncIfChanged();
    });

    if (session.isAuthenticated) {
      await Promise.all([
        preferences.getCurrentUserPreferences(),
        appState.fetchAppState()
      ]);
      session.getDeleteBinSummary();
      users.getManagedConnections();

      setTimeout(startNotificationPolling, 300);
    }

    watch(() => session.currentUser, async (newVal, oldVal) => {
      const didUserChange = newVal?.id !== oldVal?.id;

      await nextTick();

      if (didUserChange) {
        session.getUserStoreInfo();

        if (session.isAuthenticated) {
          startNotificationPolling();
        } else {
          stopNotificationPolling();
        }
      }

      if (session.isAuthenticated) {
        await Promise.all([
          preferences.getCurrentUserPreferences(),
          appState.fetchAppState()
        ]);
        session.getDeleteBinSummary();
        users.getManagedConnections();
      }
    });
  }
});
